<div mat-dialog-title>
  <span>Parse Feed</span>
</div>

<div mat-dialog-content class="parse-feed-dialog-content">
  <form #f="ngForm" class="d-flex flex-column">

    <label>Feed Source</label>
    <mat-radio-group name="source" [(ngModel)]="feed.source" class="mb-3" (ngModelChange)="updateFeedType()">
      @for (source of feedSourceKL; track source) {
        <mat-radio-button [value]="source.key" color="primary" class="mr-3">{{source.label}}</mat-radio-button>
      }
    </mat-radio-group>

    @if (feed.source === feedSource.YOUTUBE) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Select type</mat-label>
        <mat-select name="type" [(ngModel)]="feed.feedTypeYT" required>
          @for (type of feedTypeKL; track type) {
            <mat-option [value]="type.key">{{type.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (feed.feedTypeYT === feedType.CHANNEL) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Count</mat-label>
        <input name="count" type="number" matInput [(ngModel)]="feed.count" autocomplete="off" />
        <i class="fal fa-info-circle text-info float-right" matTooltip="If count is left blank, all videos from this channel will be ingested. If count is set to 10 for example, 10 most popular videos will be ingested from this channel"></i>
      </mat-form-field>
    }

    @if (feed.source === feedSource.YOUTUBE || feed.source === feedSource.RSS) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Feed URL</mat-label>
        <input name="url" [formControl]="domainControl" matInput required (ngModelChange)="updateFeedUrl($event)" [(ngModel)]="feed.url" autocomplete="off" placeholder="Enter feed URL" />
      </mat-form-field>
    }

    @if (feed.source === feedSource.UPLOAD) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Title</mat-label>
        <input name="title" matInput required [(ngModel)]="feed.title" autocomplete="off" placeholder="Enter title" />
      </mat-form-field>
    }

    @if (feed.source === feedSource.UPLOAD) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Description</mat-label>
        <input name="description" matInput [(ngModel)]="feed.description"  autocomplete="off" placeholder="Enter description" />
      </mat-form-field>
    }

    @if (feed.source === feedSource.RSS) {
      <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
        <mat-label>Date from</mat-label>
        <input matInput [max]="today"
          name="dateFrom"
          [(ngModel)]="feed.dateFrom"
          (dateChange)="dateChange($event)"
          [matDatepicker]="datePublishdAtRef">
          <mat-datepicker-toggle matSuffix [for]="datePublishdAtRef"></mat-datepicker-toggle>
          <mat-datepicker #datePublishdAtRef></mat-datepicker>
        </mat-form-field>
      }

      @if (feed.source === feedSource.RSS) {
        <div class="summary-info-box mb-3">
          Number of videos to ingest: <strong>{{videosCount}}</strong>
        </div>
      }

      @if (feed.source === feedSource.UPLOAD) {
        <ctv-video-upload-preview class="mb-3" label="upload video" (fileSelected)="videoFile = $event"
        (fileCanceled)="videoFile=null"></ctv-video-upload-preview>
      }

      @if (feed.source === feedSource.UPLOAD) {
        <ctv-image-upload-preview label="upload thumbnail"
          (fileSelected)="thumbnailFile = $event"
          (fileCanceled)="removeThumbNailImage()"
          [fileName]="false"
          [resolutonGreater]="true"
          [allowedFileTypes]="'image/png, image/jpeg'"
          [tooltip]="'PNG or JPG, 480x360'"
          [resolutionWidth]="'480'"
          [resolutionHeight]="'360'"
        [imagePreview]="thumbnailFile"></ctv-image-upload-preview>
      }

      @if (feed.newPlaylist) {
        <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
          <mat-label>New Collection Name</mat-label>
          <input name="playlistName" matInput [(ngModel)]="feed.newPlaylistName" autocomplete="off" required placeholder="Enter collection name" />
        </mat-form-field>
      }

      @if (feed.newPlaylist) {
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <label>Playlist poster</label><br/>
            <button type="button"
              mat-flat-button
              (click)="posterInput.click()"
              class="iconed">
              <i class="fas fa-cloud-upload-alt"></i>
              Upload
            </button>
            <input hidden (change)="onFileSelected()" #posterInput type="file" id="poster">
          </div>
          <div class="col-lg-6 col-md-6">
            <label>Playlist image</label><br/>
            <button type="button"
              mat-flat-button
              (click)="imageInput.click()"
              class="iconed">
              <i class="fas fa-cloud-upload-alt"></i>
              Upload
            </button>
            <input hidden (change)="onFileSelected()" #imageInput type="file" id="image">
          </div>
        </div>
      }

      <!-- <div mat-dialog-content class="py-1" *ngIf="!feed.newPlaylist">
      <ctv-playlist-autocomplete-chips (playlistSelectionChange)="onPlaylistsSelected($event)"></ctv-playlist-autocomplete-chips>
    </div> -->

    @if (feed.newPlaylist) {
      <ctv-categories-multi-select [selectedCategory]="feed.category"
        floatLabel="auto"
        formFieldAppearance="outline"
        (categorySelected)="feed.category = $event">
      </ctv-categories-multi-select>
    }

    @if (!videoType) {
      <label>Owner type</label>
    }
    @if (!videoType) {
      <mat-radio-group name="ownerType" [(ngModel)]="feed.ownerType" class="mb-3" (change)="feed.ownerId = null">
        @for (ownerType of ownerTypeKL; track ownerType) {
          <mat-radio-button color="primary" class="mr-3" value="{{ownerType.key}}">{{ownerType.label}}</mat-radio-button>
        }
      </mat-radio-group>
    }

    @if (feed.ownerType === ownerType.PUBLISHER && !videoType) {
      <ctv-publisher-autocomplete (publisherSelected)="setOwnerId($event)" floatLabel="auto" formFieldAppearance="outline"></ctv-publisher-autocomplete>
    }

    @if (feed.ownerType === ownerType.CONTENT_OWNER && !videoType) {
      <ctv-content-owner-autocomplete (contentOwnerSelected)="setOwnerId($event)" floatLabel="auto" formFieldAppearance="outline"></ctv-content-owner-autocomplete>
    }
  </form>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button class="" [mat-dialog-close]="false">
    Cancel
  </button>
  <button mat-flat-button color="primary"
          [disabled]="!f.valid || !feed.ownerType || !domainControl.valid || (!feed.category && feed.newPlaylist) ||
                      (feed.ownerType === ownerType.PUBLISHER && !feed.ownerId) ||
                      (feed.ownerType === ownerType.CONTENT_OWNER && !feed.ownerId) ||
                      (feed.source === feedSource.RSS && videosCount === 0)"
    (click)="submit()">
    <span>Finish</span>
  </button>
</div>
